module.exports = __webpack_public_path__ + "img/pic-02.5b9b6595.png";